import React from "react";
import MainPicture from "components/comp/MainPicture";
import SpdstMain from "components/comp/SpdstMain";
import GoDetail from "components/comp/GoDetail";
import Yacht from "assets/images/yacht.jpg"
import CompanyIntroMain from "components/comp/CompanyIntroMain";
import System from "components/comp/System";
import SMIMS from "components/comp/SMIMS";

const MainPage = () => {

  return (
    <main className="page-main"> 
      <MainPicture img={Yacht} alt=""/>
        <section className="company-main">
          <System/>
          <SMIMS/>
          <SpdstMain/>
          <GoDetail to={"product"} page={"제품소개"}/>
          <CompanyIntroMain/>
          <GoDetail to={"company"} page={"회사소개"}/>
        </section>
    </main>
  );
};

export default MainPage;
